export default __webpack_public_path__ + "static/media/BarebowGP2024.b7d4397a.png";